module.exports = __webpack_public_path__ + "static/img/duoshilianyun.3d1713c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/duoshilianyun.png
// module id = rljY
// module chunks = 1